// extracted by mini-css-extract-plugin
module.exports = {"input":"integer_input_input__1sDf6","toggleIcon":"integer_input_toggleIcon__1_RlH","label":"integer_input_label__r7sEX","container":"integer_input_container__2AO5i"};